import React from 'react';
import { OperationalObject } from './ui/OperationalObject';

export function PublicWorkSurface({ className = '' }) {
  return (
    <div className={`w-full flex flex-col gap-5 ${className}`}>
      
      <div className="relative">
        <div className="text-[11px] font-semibold text-ink-soft/70 tracking-widest uppercase mb-3">
          NECESIDAD ABIERTA (COMPITE EN COLA)
        </div>
        <OperationalObject 
          personName="Ana"
          personId="ID: 8A-12"
          gapDescription="EMPA no vigente"
          nextAction="Agendar"
          statusLabel="OPEN"
          statusVariant="open"
          compact={true}
          className="shadow-sm border-slate-300"
        />
      </div>

      <div className="flex flex-col items-center -my-6 relative z-10 text-brand">
        <div className="w-[1px] h-4 bg-brand/30"></div>
        <div className="bg-paper border border-line px-2 py-0.5 rounded text-[10px] font-medium text-ink-soft uppercase tracking-widest">
          Cita coordinada (hay cupo)
        </div>
        <div className="w-[1px] h-4 bg-brand/30"></div>
        <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-brand/50 -mt-1"><path d="M12 5v14"/><path d="m19 12-7 7-7-7"/></svg>
      </div>

      <div className="relative">
        <div className="text-[11px] font-semibold text-ink-soft/70 tracking-widest uppercase mb-3">
          ESPERA PROTEGIDA (NO COMPITE)
        </div>
        <OperationalObject 
          personName="Ana"
          personId="ID: 8A-12"
          gapDescription="Cita EMPA asignada"
          nextAction="Verificar asistencia"
          statusLabel="WAITING"
          statusVariant="waiting"
          compact={true}
        />
      </div>

      <div className="flex flex-col items-center -my-6 relative z-10 text-brand">
        <div className="w-[1px] h-4 bg-brand/30"></div>
        <div className="bg-paper border border-line px-2 py-0.5 rounded text-[10px] font-medium text-ink-soft uppercase tracking-widest">
          Red registra prestación (Hoy)
        </div>
        <div className="w-[1px] h-4 bg-brand/30"></div>
        <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-brand/50 -mt-1"><path d="M12 5v14"/><path d="m19 12-7 7-7-7"/></svg>
      </div>

      <div className="relative">
        <div className="text-[11px] font-semibold text-ink-soft/70 tracking-widest uppercase mb-3">
          EVIDENCIA &rarr; SIGUIENTE CICLO
        </div>
        <OperationalObject 
          personName="Ana"
          personId="ID: 8A-12"
          gapDescription="EMPA evidenciado"
          nextAction={null}
          statusLabel="EVIDENCIA CURRENT"
          statusVariant="evidence"
          compact={true}
        />
      </div>
      
      <div className="flex justify-center mt-2">
        <div className="flex items-center gap-2 text-ink-soft/60 text-[11px] font-medium uppercase tracking-widest border border-line bg-paper px-3 py-1.5 rounded-full">
          <svg aria-hidden="true" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>
          Reevaluar cascada
        </div>
      </div>

    </div>
  );
}
